import React from "react";
import { renderTitle } from "./lib/renderTitle";
import s from "./style.module.scss";
import { Link } from "react-router-dom";
import Time from "./icons/Time";
import Warning from "./icons/Warning";
import { ITransaction } from "widgets/HistoryList/api/models";

const HistoryItem: React.FC<ITransaction> = ({
  activated_time,
  created,
  tr_value,
  event,
  bonus,
}) => {
  return (
    <li className={s.item}>
      <div className={s.right}>
        <h4 className={s.title}>
          {(event && event.title) || (bonus && bonus.title)}
        </h4>

        <span className={s.date}>{new Date(created).toLocaleDateString()}</span>
        {/* {amount && <span className={s.amount}>Сумма покупки {amount} ₽</span>} */}

        {/* {check && (
          <Link className={s.check} to={check}>
            Электронный чек
          </Link>
        )} */}
      </div>

      <div className={s.left}>
        {/* {status === "checking" && <Time />}
        {status === "error" && <Warning />} */}
        {tr_value && (
          <div className={s.bonuses}>
            {tr_value > 0 ? "+" + tr_value : tr_value}
          </div>
        )}
      </div>
    </li>
  );
};

export default HistoryItem;
